// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__4mn17","text":"styles_text__Kp73E","chevron":"styles_chevron__JmtYp","skeleton-animation":"styles_skeleton-animation__g4Fqj","info":"styles_info__G7__M"};